// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#contact-offices[data-v-03b1e37a]  a{color:#fff}", ""]);
// Exports
module.exports = exports;
